/* unplugin-vue-components disabled */import script from "./navigationbar.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationbar.vue?vue&type=script&setup=true&lang=js"

import "./navigationbar.vue?vue&type=style&index=0&id=1ca31e36&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca31e36"]])

export default __exports__